module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {


let groupName = filterGroup.nameDe || filterGroup.name;
if ( 'dynamic' === filterGroup.identifier ) {
	let split = groupName.split( '|' );
	groupName = split[1];
}

const getFilterGroupFilter = ( groupName, filterName, filterValue = null ) => {

    const found = filterJSON.find( group => group.identifier === groupName ) || {};
    const filters = found.filter || [];
	return filters.find( filter => {

		if ( filter.name !== filterName ) {
			return false;
		}

		if ( null === filterValue ) {
			return true;
		}

		return filter.value === filterValue;
	});
};

;
__p += '\n';
 if ( 'radio' === filterGroup.type ) { ;
__p += '\n	<!-- Empty Input, so the value gets cleared, when empty have the correct name -->\n	<input type="hidden" name="' +
((__t = ( filterGroup.input_name )) == null ? '' : __t) +
'" value="" />\n';
 } ;
__p += '\n';
 if ( 'checkbox' === filterGroup.type ) { ;
__p += '\n	<!-- Empty Input, so the value gets cleared, when empty have the correct name -->\n	<input type="hidden" name="' +
((__t = ( filterGroup.input_name )) == null ? '' : __t) +
'[]" value="" />\n';
 } ;
__p += '\n\n<div class="mdl_filter__item-mobile-title-container en_hidden_desktop_up">\n	<div class="mdl_filter__item-mobile-title">' +
((__t = ( groupName )) == null ? '' : __t) +
'</div>\n    <button class="mdl_filter__item-mobile-reset js_filter__item-mobile-reset en_hidden" type="reset">Zurücksetzen</button>\n	<button class="mdl_filter__item-mobile-close js_filter__item-mobile-close" type="button"></button>\n</div>\n\n';
 if ( filterGroup.search ) { ;
__p += '\n<div class="mdl_filter__item-search-box">\n	<div class="input_wrapper">\n		<input type="text" class="mdl_filter__item-search-input input" placeholder="Suchen">\n	</div>\n</div>\n';
 } ;
__p += '\n\n<div class="mdl_filter__item-content">\n\n	';
 if ( 'pricerange' === filterGroup.type ) { ;
__p += '\n		<div class="mdl_filter__field">\n			<div class="mdl_filter__field-content">\n\n				';
 // Render Single Item for Pricerange Slider. ;
__p += '\n				' +
((__t = ( render( 'filter-item', {
					filterGroup,
				}) )) == null ? '' : __t) +
'\n			</div>\n		</div>\n	';
 } else if ( 'category' === filterGroup.type ) { ;
__p += '\n		';
 if ( filterGroup.filter[0] ) { ;
__p += '\n			<input type="hidden" name="shop" value="shop" />\n			<input type="radio" name="shop" value="shop" class="en_hidden" checked />\n		';
 } ;
__p += '\n		<div class="mdl_filter__field">\n			<div class="mdl_filter__field-content">\n				<div class="mdl_filter__field-tree">\n					<div class="mdl_filter__field-tree-root">\n						<ul class="mdl_filter__field-tree-items" data-title="' +
((__t = ( groupName )) == null ? '' : __t) +
'" data-level="0">\n\n							';
 filterGroup.filter.forEach( (filter) => { ;
__p += '\n\n								';
 Object.values( filter.categories ).forEach( ( category, index ) => { ;
__p += '\n\n									' +
((__t = ( render( 'filter-item', {
										filterGroup,
										filter: category,
										index,
									} ) )) == null ? '' : __t) +
'\n\n								';
 }) ;
__p += '\n							';
 }); ;
__p += '\n						</ul>\n					</div>\n				</div>\n			</div>\n		</div>\n	';
 } else if ( Array.isArray( filterGroup.filter ) ) { ;
__p += '\n\n		<div class="mdl_filter__field">\n			';
 if ( 'new' === filterGroup.multi ) { ;
__p += '\n				<div class="mdl_filter__field-title">' +
((__t = ( groupName )) == null ? '' : __t) +
'</div>\n			';
 } ;
__p += '\n			<div class="mdl_filter__field-content">\n				<div class="mdl_filter__field-choices">\n					';
 // Sorting filters to be display selected on top. ;
__p += '\n					';
 filterGroup.filter.sort( ( filterA, filterB ) => filterB.selected - filterA.selected ); ;
__p += '\n					';
 filterGroup.filter.forEach( (filter, index) => { ;
__p += '\n						' +
((__t = ( render( 'filter-item', {
								filterGroup,
								filter,
								index,
							} ) )) == null ? '' : __t) +
'\n\n						';
 if ( 'themes' === filterGroup.identifier && Array.isArray( filter.children ) && filter.children.length > 0 ) { ;
__p += '\n							';
 filter.children.forEach( (subFilter, subIndex) => { ;
__p += '\n								' +
((__t = ( render( 'filter-item', {
									filterGroup,
									filter: subFilter,
									index: index + '_' + subIndex,
								}) )) == null ? '' : __t) +
'\n							';
 }) ;
__p += '\n						';
 } ;
__p += '\n					';
 } ); ;
__p += '\n				</div>\n			</div>\n		</div>\n	';
 } ;
__p += '\n\n	';
 if ( 'new' === filterGroup.multi ) { ;
__p += '\n		';
 const newFilter = getFilterGroupFilter( 'salenew', 'new', '1' ) ;
__p += '\n		';
 if ( newFilter ) { ;
__p += '\n			';
 const filterId = [ filterGroup.input_name, newFilter.name, newFilter.value ].join( '_' ) ;
__p += '\n			<div class="mdl_filter__field">\n				<div class="mdl_filter__field-content">\n					<div class="toggle">\n						<input type="hidden" name="' +
((__t = ( newFilter.name )) == null ? '' : __t) +
'" value="0" />\n						<input type="checkbox" class="toggle__input checkbox replace" id="' +
((__t = ( filterId )) == null ? '' : __t) +
'" name="' +
((__t = ( newFilter.name )) == null ? '' : __t) +
'" value="' +
((__t = ( newFilter.value )) == null ? '' : __t) +
'" data-count="' +
((__t = ( newFilter.count )) == null ? '' : __t) +
'" ' +
((__t = ( newFilter.selected ? 'checked' : '' )) == null ? '' : __t) +
' />\n						<label class="toggle__label label" for="' +
((__t = ( filterId )) == null ? '' : __t) +
'">\n							<span class="toggle__title">Nur neue Artikel</span>\n						</label>\n					</div>\n				</div>\n			</div>\n		';
 } ;
__p += '\n	';
 } ;
__p += '\n\n	';
 if ( 'sale' === filterGroup.multi ) { ;
__p += '\n		';
 const saleFilter = getFilterGroupFilter( 'salenew', 'sale', '1' ); ;
__p += '\n		';
 if ( saleFilter ) { ;
__p += '\n			';
 const filterId = [ filterGroup.input_name, saleFilter.name, saleFilter.value ].join( '_' ) ;
__p += '\n			<div class="mdl_filter__field">\n				<div class="mdl_filter__field-content">\n					<div class="toggle">\n						<input type="hidden" name="' +
((__t = ( saleFilter.name )) == null ? '' : __t) +
'" value="0" />\n						<input type="checkbox" class="toggle__input checkbox replace" id="' +
((__t = ( filterId )) == null ? '' : __t) +
'" name="' +
((__t = ( saleFilter.name )) == null ? '' : __t) +
'" value="' +
((__t = ( saleFilter.value )) == null ? '' : __t) +
'" data-count="' +
((__t = ( saleFilter.count )) == null ? '' : __t) +
'" ' +
((__t = ( saleFilter.selected ? 'checked' : '' )) == null ? '' : __t) +
' />\n						<label class="toggle__label label" for="' +
((__t = ( filterId )) == null ? '' : __t) +
'">\n							<span class="toggle__title">Nur reduzierte Artikel</span>\n						</label>\n					</div>\n				</div>\n			</div>\n		';
 } ;
__p += '\n	';
 } ;
__p += '\n</div>\n\n';
 if ( filterGroup.search ) { ;
__p += '\n	<div class="mdl_filter__item-choices--message en_hidden">Keine ' +
((__t = ( filterGroup.name )) == null ? '' : __t) +
' gefunden.</div>\n';
 } ;
__p += '\n\n<div class="mdl_filter__item-controls">\n    <button type="reset" class="en_button en_button--style_minimal en_button--size_small en_button--shrink mdl_filter__item-control en_hidden_desktop_down" disabled>Zurücksetzen</button>\n    <button type="submit" class="mdl_filter__item-control-apply en_button en_button--style_solid en_button--shrink mdl_filter__item-control" disabled>\n		<span class="mdl_filter__item-control-apply-text">Speichern</span>\n	</button>\n</div>\n';

}
return __p
};
